import { render, staticRenderFns } from "./screen-flow-settings.vue?vue&type=template&id=032c34de&scoped=true"
import script from "./screen-flow-settings.vue?vue&type=script&lang=js"
export * from "./screen-flow-settings.vue?vue&type=script&lang=js"
import style0 from "./screen-flow-settings.vue?vue&type=style&index=0&id=032c34de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c34de",
  null
  
)

export default component.exports